import * as echarts from "echarts"
import EChartsController from "../echarts_controller"

export default class extends EChartsController {
  static values = {
    startDate: String,
    endDate: String,
    hits: { type: Object, default: { incoming: [], outgoing: [] } },
  }

  chartTargetConnected(target) {
    super.chartTargetConnected(target)

    this.renderChart(
      this.chart,
      this.startDateValue,
      this.endDateValue,
      this.hitsValue,
    )
  }

  resize() {
    this.chart?.resize()
  }

  renderChart(chart, startDate, endDate, hits) {
    chart.setOption({
      tooltip: {
        trigger: "axis",
        axisPointer: {
          label: {
            formatter: function (params) {
              const date = new Date(params.value)
              return date.toISOString().split("T")[0]
            },
          },
        },
      },
      legend: {
        data: ["Outgoing", "Incoming"],
        bottom: 0,
        left: 0,
        icon: "circle",
        itemWidth: 13,
        itemHeight: 13,
        textStyle: {
          color: "#F3F3F3B2",
          fontSize: 14,
        },
      },
      xAxis: {
        type: "time",
        min: startDate,
        max: endDate,
        minInterval: 24 * 60 * 60 * 1000,
      },
      yAxis: {
        type: "value",
        splitLine: {
          lineStyle: {
            color: "#F3F3F31A",
          },
        },
      },
      series: [
        {
          name: "Incoming",
          type: "line",
          smooth: true,
          showSymbol: false,
          data: Object.entries(hits).map(([date, counts]) => {
            return [date, counts.incoming]
          }),
          itemStyle: {
            color: "#D48300BF",
          },
        },
        {
          name: "Outgoing",
          type: "line",
          smooth: true,
          showSymbol: false,
          data: Object.entries(hits).map(([date, counts]) => {
            return [date, counts.outgoing]
          }),
          itemStyle: {
            color: "#2235B3BF",
          },
        },
      ],
    })
  }
}
